function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import classnames from 'classnames';
import T from 'prop-types';
import Button from './Button';
import classNames from 'classnames';
var oppositeDirection = {
    left: 'right',
    right: 'left',
    down: 'up',
    up: 'down'
};
var getIcon = function(direction, isOpen) {
    return "caret-".concat(isOpen ? oppositeDirection[direction] : direction);
};
var CollapseButton = function(props) {
    var id = props.id, _props_openDirection = props.openDirection, openDirection = _props_openDirection === void 0 ? 'up' : _props_openDirection, onClick = props.onClick, openText = props.openText, closeText = props.closeText, isOpen = props.isOpen, tooltipProps = props.tooltipProps, className = props.className, variant = props.variant, disabled = props.disabled;
    var _obj;
    return /*#__PURE__*/ React.createElement(Button, {
        id: id,
        disabled: disabled,
        className: classnames('CollapseButton', (_obj = {
            isOpen: isOpen
        }, _define_property(_obj, className, className), _define_property(_obj, 'flex-row-reverse', openDirection === 'right'), _obj)),
        onClick: onClick,
        icon: getIcon(openDirection, isOpen),
        tooltipProps: tooltipProps,
        variant: variant
    }, !isOpen && /*#__PURE__*/ React.createElement("span", {
        className: classNames({
            'mr-2': !isOpen && openDirection === 'left',
            'ml-2': !isOpen && openDirection === 'right'
        })
    }, isOpen ? openText : closeText));
};
CollapseButton.propTypes = {
    id: T.string,
    openDirection: T.string,
    onClick: T.func,
    openText: T.string,
    closeText: T.string,
    isOpen: T.bool,
    tooltipProps: T.shape()
};
export default CollapseButton;
